import { onboarding } from '@services';

export interface IPatchApproximateMatchByProductId {
  studioId: string;
  fileId: string;
  groupId: string;
  confirm: boolean;
  approxMatch?: {
    image?: string;
    mpn?: string;
    mfr?: string;
    productId?: string;
    productName?: string;
  };
}

const patchApproximateMatchByProductId = async ({
  groupId,
  studioId,
  fileId,
  confirm,
  approxMatch,
}: IPatchApproximateMatchByProductId): Promise<void> => {
  await onboarding.post('/api/v1/assets/approx', {
    groupId,
    studioId,
    fileId,
    confirm,
    approxMatch,
  });
};

export { patchApproximateMatchByProductId };
